import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'waterLight',
      d: 'M-2,-2h1v0.5h-1zM-3,-1.5h3v1h-3zM-3.5,-0.5h4.5v0.5h-4.5zM2,-0.5h1.5v0.5h-1.5zM-1,0h3.5v0.5h-3.5zM0,0.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 36,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
